/**
 * @generated SignedSource<<c2963f9a5bad3f233d9801569bdcf43a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type composerQueriesMerchantProductOptionsQuery$variables = {
  salesChannelId: string;
  sku: string;
};
export type composerQueriesMerchantProductOptionsQuery$data = {
  readonly merchantProductOptions: ReadonlyArray<{
    readonly isGlobal: boolean;
    readonly label: string;
    readonly metadata: ReadonlyArray<{
      readonly key: string;
      readonly value: string;
    }> | null;
    readonly optionID: string;
    readonly values: ReadonlyArray<{
      readonly label: string;
      readonly valueID: string;
    }>;
  }>;
};
export type composerQueriesMerchantProductOptionsQuery = {
  response: composerQueriesMerchantProductOptionsQuery$data;
  variables: composerQueriesMerchantProductOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesChannelId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sku"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "environment",
        "value": "COMPOSER"
      },
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelId"
      },
      {
        "kind": "Variable",
        "name": "sku",
        "variableName": "sku"
      }
    ],
    "concreteType": "MerchantProductGraphQLOption",
    "kind": "LinkedField",
    "name": "merchantProductOptions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "optionID",
        "storageKey": null
      },
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "MerchantProductGraphQLOptionValue",
        "kind": "LinkedField",
        "name": "values",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "valueID",
            "storageKey": null
          },
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isGlobal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "KeyValuePairOfStringAndString",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesMerchantProductOptionsQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "composerQueriesMerchantProductOptionsQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "d3f81744c86bde23fe88997b79137871",
    "id": null,
    "metadata": {},
    "name": "composerQueriesMerchantProductOptionsQuery",
    "operationKind": "query",
    "text": "query composerQueriesMerchantProductOptionsQuery(\n  $sku: String!\n  $salesChannelId: ID!\n) {\n  merchantProductOptions(sku: $sku, salesChannelID: $salesChannelId, environment: COMPOSER) {\n    optionID\n    label\n    values {\n      valueID\n      label\n    }\n    isGlobal\n    metadata {\n      key\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36bd2757b26c04879d4d7a31516fddd0";

export default node;
